import { FC } from 'react';

import { IconProps } from '../types';

export const InstagramIcon: FC<IconProps> = ({
	size,
	height = 18,
	width = 18,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 18"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M4.897 1.547h8.206a3.355 3.355 0 0 1 3.35 3.35v8.163a3.355 3.355 0 0 1-3.35 3.35H4.897a3.355 3.355 0 0 1-3.35-3.35V4.897a3.355 3.355 0 0 1 3.35-3.35m4.082 4.21h.042c1.762 0 3.222 1.46 3.222 3.222 0 1.804-1.46 3.264-3.222 3.264H8.98c-1.762 0-3.222-1.46-3.222-3.264 0-1.762 1.46-3.222 3.222-3.222m0-1.676h.042c2.664 0 4.898 2.234 4.898 4.898 0 2.706-2.234 4.897-4.898 4.897H8.98c-2.664 0-4.855-2.191-4.855-4.897 0-2.664 2.191-4.898 4.855-4.898m4.854-.945c.558 0 1.031.473 1.031 1.031 0 .559-.473 1.031-1.031 1.031a1.018 1.018 0 0 1-1.031-1.031c0-.558.43-1.03 1.031-1.03M4.854 0h8.292C15.809 0 18 2.19 18 4.854v8.249c0 2.663-2.19 4.854-4.854 4.854H4.854C2.191 17.957 0 15.767 0 13.103V4.854C0 2.191 2.191 0 4.854 0"
		/>
	</svg>
);
